import isServerSide from '@helpers/misc/isServerSide'
import {OrionApolloClient} from '@orion-js/graphql-client'
import getEnv from '@providers/getEnv'
import services from '@providers/services'

import createApolloClient from './createApolloClient'

const env = getEnv()
const clients: {[key: string]: OrionApolloClient<any>} = {}

export default function getClients() {
  // On the server, we want to recreate the clients on every request
  // This is because we don't want to preserve the apollo cache between requests
  // Otherwise, RAM usage would grow indefinitely as every website would have its own cache
  if (Object.keys(clients).length > 0) return clients

  for (const key in services) {
    const service = services[key]
    const {urls} = service
    const url = urls[env]
    clients[key] = createApolloClient({
      endpointURL: url,
      useSubscriptions: isServerSide() ? false : service.useSubscriptions
    })
  }

  return clients
}
